import type { HistoryItem } from '../MatchmakingHistoryPopover';
import { truncateText } from '../../utils/history.utils';

type HistoryItemButtonProps = {
  item: HistoryItem;
  onSelect: (item: HistoryItem) => void;
  onClose: () => void;
};

export const HistoryItemButton = ({ item, onSelect, onClose }: HistoryItemButtonProps) => {
  const handleClick = () => {
    onSelect(item);
    onClose();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full text-left px-4 py-3 rounded-lg bg-[#F9FAFB] hover:bg-[#F3F4F6] transition-colors border border-transparent hover:border-[#E5E7EB]"
    >
      <p className="font-termina text-sm text-[#1F2937] leading-relaxed">
        {truncateText(item.promptText)}
      </p>
    </button>
  );
};

